import axios from 'axios';
import _ from 'lodash';

import * as api from "./api";
import * as basicConstants from '../constants/basic';
import * as alertConstants from '../constants/alertMsg';

export const apiList = {
  apiUserLogin: (query) => {
    return api.apiUserLogin(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  apiUserGoogleLogin: (query) => {
    return api.apiUserGoogleLogin(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  apiUserCheckStatus: () => {
    return api.apiUserCheckStatus()
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  apiUserLogout: () => {
    return api.apiUserLogout()
      .then(res => {
        return res;
      })
      .catch(err => {
        return err;
      })
  },
  apiGetOwnedAdAccount: (query, cancelToken) => {
    return api.apiGetOwnedAdAccount({
      params: query,
      cancelToken: cancelToken
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  getUsers: (query, cancelToken) => {
    return api.apiGetUsers({
      params: query,
      cancelToken: cancelToken
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  transReports: (query, cancelToken) => {
    return api.apiTransReports({
      params: query,
      cancelToken: cancelToken
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //-----------------------------------------------Facebook-----------------------------------------------
  apiGetFacebookAdAccounts: (query) => {
    return api.apiGetFacebookAdAccounts(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  apiBindFacebookAdAccounts: (query) => {
    return api.apiBindFacebookAdAccounts(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  getReportList: (query, cancelToken) => {
    return api.apiReportList({
      params: query,
      cancelToken: cancelToken
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  createReport: (query) => {
    return api.apiCreateReport(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  updateReport: (query) => {
    const { data, config } = query;
    return api.apiUpdateReport(data, config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  deleteReport: (query) => {
    return api.apiDeleteReport(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  getCampaign: (query) => {
    return api.apiGetCampaign({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  testSend: (query) => {
    return api.apiTestSend(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  sendAllEmails: (query) => {
    return api.apiSendAllEmails(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  testDownload: (query) => {
    const config = {
      params: query,
      responseType: 'arraybuffer'
    }
    return api.apiTestDownload(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  downloadCustomReport: (query) => {
    const config = {
      params: query,
      responseType: 'arraybuffer'
    }
    return api.apiDownloadCustomReport(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  downloadExternaleport: (query) => {
    const { data, config } = query;
    const configData = {
      params: config,
      responseType: "arraybuffer",
    }
    return api.apiDownloadExternalReport(data, configData)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  columnDefinition: (query) => {
    return api.apiColumnDefinition()
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  customEvents: (query) => {
    return api.apiCustomEvents({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //-----------------------------------------------google-----------------------------------------------
  //account
  apiGetGoogleAdAccounts: (query) => {
    return api.apiGetGoogleAdAccounts(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  apiBindGoogleAdAccounts: (query) => {
    return api.apiBindGoogleAdAccounts(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  //report
  getGoogleReportList: (query, cancelToken) => {
    return api.apiGoogleReportList({
      params: query,
      cancelToken: cancelToken
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  createGoogleReport: (query) => {
    return api.apiGoogleCreateReport(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  updateGoogleReport: (query) => {
    const { data, config } = query;
    return api.apiGoogleUpdateReport(data, config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  deleteGoogleReport: (query) => {
    return api.apiGoogleDeleteReport(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  //Fields
  // googleDefinition: (query) => {
  //   return api.apiGoogleDefinition()
  //           .then(res => {
  //             return res;
  //           })
  //           .catch(err => {
  //             return err.response || err;
  //           })
  // },
  googleCustomFields: (query) => {
    return api.apiGoogleCustomFields({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  googleGetCampaign: (query) => {
    return api.apiGoogleGetCampaign({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //send
  googleTestSend: (query) => {
    return api.apiGoogleTestSend(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  googleSendAllEmails: (query) => {
    return api.apiGoogleSendAllEmails(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //downlodad
  googleTestDownload: (query) => {
    const config = {
      params: query,
      responseType: 'arraybuffer'
    }
    return api.apiGoogleTestDownload(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  downloadGoogleReport: (query) => {
    const config = {
      params: query,
      responseType: 'arraybuffer'
    }
    return api.apiGoogleDownloadReport(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  downloadGoogleExternalReport: (query) => {
    const { data, config } = query;
    const configData = {
      params: config,
      responseType: "arraybuffer",
    }
    return api.apiGoogleDownloadExternalReport(data, configData)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //-----------------------------------------------line-----------------------------------------------
  //account
  apiGetLineAdAccounts: (query) => {
    return api.apiGetLineAdAccounts(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  apiBindLineAdAccounts: (query) => {
    return api.apiBindLineAdAccounts(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  //report
  getLineReportList: (query, cancelToken) => {
    return api.apiLineReportList({
      params: query,
      cancelToken: cancelToken
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  createLineReport: (query) => {
    return api.apiLineCreateReport(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  updateLineReport: (query) => {
    const { data, config } = query;
    return api.apiLineUpdateReport(data, config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  deleteLineReport: (query) => {
    return api.apiLineDeleteReport(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  //Fields
  lineDefinition: (query) => {
    return api.apiLineDefinition()
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  lineCustomFields: (query) => {
    return api.apiLineCustomFields({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  lineGetTarget: (query) => {
    return api.apiLineGetTarget({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  lineGetCampaign: (query) => {
    return api.apilineGetCampaign({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //send
  lineTestSend: (query) => {
    return api.apiLineTestSend(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  lineSendAllEmails: (query) => {
    return api.apiLineSendAllEmails(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //downlodad
  lineTestDownload: (query) => {
    const config = {
      params: query,
      responseType: 'arraybuffer'
    }
    return api.apiLineTestDownload(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  downloadLineReport: (query) => {
    const config = {
      params: query,
      responseType: 'arraybuffer'
    }
    return api.apiLineDownloadReport(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  downloadLineExternalReport: (query) => {
    const { data, config } = query;
    const configData = {
      params: config,
      responseType: "arraybuffer",
    }
    return api.apiLineDownloadExternalReport(data, configData)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //-----------------------------------------------Taboola-----------------------------------------------
  //account
  apiGetTaboolaAdAccounts: (query) => {
    return api.apiGetTaboolaAdAccounts(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  apiBindTaboolaAdAccounts: (query) => {
    return api.apiBindTaboolaAdAccounts(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  //report
  getTaboolaReportList: (query, cancelToken) => {
    return api.apiTaboolaReportList({
      params: query,
      cancelToken: cancelToken
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  createTaboolaReport: (query) => {
    return api.apiTaboolaCreateReport(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  updateTaboolaReport: (query) => {
    const { data, config } = query;
    return api.apiTaboolaUpdateReport(data, config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  deleteTaboolaReport: (query) => {
    return api.apiTaboolaDeleteReport(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response;
      })
  },
  taboolaCustomFields: (query) => {
    return api.apiTaboolaCustomFields({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  taboolaGetCampaign: (query) => {
    return api.apiTaboolaGetCampaign({
      params: query,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //send
  taboolaTestSend: (query) => {
    return api.apiTaboolaTestSend(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  taboolaSendAllEmails: (query) => {
    return api.apiTaboolaSendAllEmails(query)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  //downlodad
  taboolaTestDownload: (query) => {
    const config = {
      params: query,
      responseType: 'arraybuffer'
    }
    return api.apiTaboolaTestDownload(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  downloadTaboolaReport: (query) => {
    const config = {
      params: query,
      responseType: 'arraybuffer'
    }
    return api.apiTaboolaDownloadReport(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
  downloadTaboolaExternalReport: (query) => {
    const { data, config } = query;
    const configData = {
      params: config,
      responseType: "arraybuffer",
    }
    return api.apiTaboolaDownloadExternalReport(data, configData)
      .then(res => {
        return res;
      })
      .catch(err => {
        return err.response || err;
      })
  },
}

export const getCancelData = () => {
  return axios.CancelToken.source();
}
